import { HttpEvent, HttpRequest, HttpInterceptor, HttpHandler, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Observable, switchMap, from, catchError, throwError } from 'rxjs';
import { fetchAuthSession } from 'aws-amplify/auth';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {

    return from(fetchAuthSession()).pipe(
      switchMap(session => {
        const token = session?.tokens?.accessToken.toString();
        if (token) {
          const cloned = req.clone({
            setHeaders: {
              Authorization: `${token}`
            }
          });
          return next(cloned);
        }
        return next(req);
      }),
      catchError((error: HttpErrorResponse) => {
        console.log('error', error);
        return throwError(() => error);
      })
    );
}

